export const GAME_RULES = Object.freeze({
  battle: {
    scoutSeconds: 30,
    battleSeconds: 150,
    deploymentRadius: { min: 10.5, max: 14 },
    practiceRewardMultiplier: .15,
    repeatOpponentRewardMultipliers: [1, .65, .35, .15],
    stamp: { startingCharge: 50, chargePerDestruction: 1.25, durationMs: 6000, uses: 1 },
    skyCurrent: { width: 3.4, speedMultiplier: 1.25, exitBuffMs: 3000 }
  },
  economy: {
    offlineMinutes: 480,
    baseStorage: { gold: 2500, wood: 2200, dew: 180 },
    vaultPerLevel: 1800,
    timberStoragePerLevel: 1400,
    dewStoragePerLevel: 120,
    collectorBasePerMinute: { gold: 0, wood: 0, dew: 0 },
    winProfitTarget: { min: .25, max: .4 }
  },
  leader: {
    rarityBonuses: { C: 0, R: .08, SR: .16, UR: .24 },
    levelBonusPerLevel: .02,
    maximumLevelBonus: .28
  }
});

export const BUILDING_LIMITS = Object.freeze({
  hall: [1, 1, 1, 1, 1],
  mint: [1, 2, 2, 3, 3], timber: [1, 1, 2, 2, 3], grove: [0, 1, 1, 2, 2], well: [0, 1, 1, 2, 2],
  rally: [1, 1, 2, 2, 2], arrow: [0, 2, 3, 4, 5], vault: [0, 1, 1, 2, 2], dew: [0, 1, 1, 2, 2],
  builder: [0, 1, 1, 1, 2], scout: [0, 0, 1, 1, 1], workshop: [0, 0, 1, 1, 1], bell: [0, 0, 1, 1, 2],
  guardian: [0, 0, 0, 1, 2], laboratory: [0, 0, 0, 1, 1]
});

export function buildingLimit(type, hallLevel) {
  const levels = BUILDING_LIMITS[type];
  return levels?.[Math.max(1, Math.min(5, hallLevel)) - 1] ?? 0;
}

export function targetScore(type, buildingType, distanceSq) {
  const distance = Math.sqrt(Math.max(0, distanceSq));
  const preferred = {
    runner: ['mint', 'timber', 'grove', 'well', 'vault', 'dew'],
    smith: ['arrow', 'bell', 'guardian'],
    ember: ['arrow', 'bell', 'guardian']
  }[type] || [];
  const preference = preferred.includes(buildingType) ? -8 : 0;
  const backline = type === 'ember' ? -Math.max(0, 8 - distance) * .35 : 0;
  return distance + preference + backline;
}

export function villageVisualStage(buildings = []) {
  return buildings.filter(building => building?.type !== 'hall' && !building?.underConstruction).length;
}
